import React from 'react';
import { Grid } from '@mui/material';
import { colors } from './Theme/WebTheme';
import CircularProgress from '@mui/material/CircularProgress';

function CircularLoading() {

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent={'center'}
      style={{ minHeight: '100vh' }}
    >
      <CircularProgress style={{ color: colors.Primary }} />

    </Grid>
  )
}

export default CircularLoading;